import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export const FooterLink = ({ href, children, className }) => {
    return (_jsx("li", { className: classNames('mr-4 last:mr-0 md:mr-6', className), children: _jsx("a", { href: href, className: "hover:underline", children: children }) }));
};
